import React, {
  useMemo,
} from 'react';
import AutoComplete from 'core/components/AutoComplete';
import ChevronDownIcon from 'core/icons/chevronDown';
import {
  PopulateSupportOrganizationDTO,
} from 'dtos';

type Props = {
  organizations: PopulateSupportOrganizationDTO[];
  selectedOrg: PopulateSupportOrganizationDTO | null;
  onSelect: (org: PopulateSupportOrganizationDTO | null) => void;
};

export default function OrgSelect({
  organizations,
  selectedOrg,
  onSelect,
}: Props) {
  const sortedOrganizations = useMemo(
    () => [...organizations].sort((a, b) => a.displayName.localeCompare(b.displayName)),
    [organizations],
  );

  return (
    <div className="w-96">
      <AutoComplete<PopulateSupportOrganizationDTO>
        id="org-select"
        label="Organization"
        value={selectedOrg}
        options={sortedOrganizations}
        getLabel={(option) => option?.displayName ?? ''}
        onChange={(value) => onSelect(value as PopulateSupportOrganizationDTO | null)}
        placeholder="Select an organization"
        openOnFocus
        filterSelectedOptions={false}
        loadingText="Loading..."
        noOptionsText="No organizations found"
        popupIcon={<ChevronDownIcon className="text-slate-500" />}
        className="w-full"
        dropdownClassName="!p-0"
        classes={{
          inputRoot: '!pr-2 !py-2',
        }}
        isOptionEqualToValue={(option, value) => (
          option?.organizationId === (
            typeof value === 'string'
              ? value
              : value?.organizationId
          )
        )}
      />
    </div>
  );
}
